export const ROUTES = {
  CHARITY_DASHBOARD: '/dashboard-charity',
}
